const asText = (value) => {
  if (value == null) return null;
  const text = String(value).trim();
  return text === '' ? null : text;
};

/**
 * Значение поля, общее для всех устройств секции.
 * Если хотя бы у одного другое или пусто — null: в карточках поле не дублируем.
 */
export const sharedText = (devices, key) => {
  if (!Array.isArray(devices) || devices.length === 0) return null;
  const first = asText(devices[0]?.[key]);
  if (first == null) return null;
  return devices.every((device) => asText(device?.[key]) === first) ? first : null;
};

export const sharedBoolean = (devices, key) => {
  if (!Array.isArray(devices) || devices.length === 0) return null;
  const first = Boolean(devices[0]?.[key]);
  return devices.every((device) => Boolean(device?.[key]) === first) ? first : null;
};

/** Показывать поле в карточке только когда оно отличается от остальных. */
export const isCardFieldUnique = (devices, key, value) => {
  if (sharedText(devices, key) != null) return false;
  return asText(value) != null;
};
